import{useEffect as o}from"react";var n=function(){o(function(){return document.body.classList.add("vchasno-ui-overflow-hidden"),function(){document.body.classList.remove("vchasno-ui-overflow-hidden")}},[])};export{n as useLockBodyScroll};
//# sourceMappingURL=useLockBodyScroll.js.map
